import React, { useState } from "react";
import SearchBar from "./SearchBar";
import Navbar from "./Navbar";
import hamburger_icon from "../assets/icons/hamburger_icon.png";

//-> /subscriptions-models/renew

const RenewSubscribePackage = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };
  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            className="object-contain"
            alt="hamburger"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Dashboard" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <p className="text-[18px] mt-8 ml-4">Current Subscription Packages</p>

      {/* First Plan */}
      <div className=" flex justify-center items-center ml-4 mt-16">
        <div className="relative w-[55%] flex justify-center flex-col items-center shadow-md rounded-lg plan--card ">
          <p className="text-[18px] text-[#333333] font-bold mt-5 mb-4 text-center">
            Organizer Pro
          </p>
          <p className="absolute top-2 right-3 text-[12px] text-[#828282] italic">
            order iD- 13E4347RY
          </p>
          <p className="items-center font-bold text-[12px] w-[70%] justify-start  text-center">
            01st Jan 2024
          </p>
          <p className="items-center text-[#828282] text-[12px] mt-2 w-[70%] justify-start  text-center">
            Subscription has endED
          </p>
          <p className="items-center text-[#828282] text-[16px] mt-4 w-[70%] justify-start text-center">
            Multi-exhibitor, post-exhibitions support.
          </p>
          <div className="bg-[#F0F0F0] w-full text-[24px] font-bold pl-2 mt-5 py-1 text-black text-center">
            $500
            <span className="pl-1 text-[#746E7B] text-[20px]">/month</span>
          </div>

          <div className="flex justify-center w-full mt-6 mb-4 text-white">
            <button className=" w-[30%] py-2 rounded-lg bg-[#2F80ED] text-[14px] ">
              Renew
            </button>
          </div>
        </div>
      </div>

      <div className="flex justify-center mt-10 mb-4">
        <p className="underline text-[#2F80ED] text-[18px] cursor-pointer">
          View all Packages
        </p>
      </div>
    </div>
  );
};

export default RenewSubscribePackage;
